(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-progress"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-progress')) {
    customElements.define('cart-progress', class extends HTMLElement {
      connectedCallback() {
        // 区块刷新后同步两个购物车入口，无需重复请求购物车接口。
        queueMicrotask(() => {
          if (!this.isConnected) return;

          const content = this.innerHTML;
          const hidden = this.hidden;
          document.querySelectorAll('cart-progress').forEach((progress) => {
            if (progress === this) return;
            if (progress.innerHTML !== content) progress.innerHTML = content;
            progress.hidden = hidden;
          });
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
